var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 960 540",
    width: 960,
    height: 540,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466 249L454 381L554 282Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 381L565 323L554 282Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466 249L385 330L454 381Z",
    fill: "#081e2e",
    stroke: "#081e2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 447L492 445L454 381Z",
    fill: "#2975ac",
    stroke: "#2975ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 381L560 438L565 323Z",
    fill: "#3184c4",
    stroke: "#3184c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466 249L362 304L385 330Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 445L560 438L454 381Z",
    fill: "#3184c4",
    stroke: "#3184c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 308L611 211L554 282Z",
    fill: "#226595",
    stroke: "#226595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 282L488 145L466 249Z",
    fill: "#113955",
    stroke: "#113955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 308L554 282L565 323Z",
    fill: "#2975ac",
    stroke: "#2975ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 211L488 145L554 282Z",
    fill: "#42a5f5",
    stroke: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466 249L381 151L362 304Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 438L642 416L565 323Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 393L355 447L385 330Z",
    fill: "#081e2e",
    stroke: "#081e2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 330L355 447L454 381Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689 355L685 308L565 323Z",
    fill: "#42a5f5",
    stroke: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 211L506 122L488 145Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 145L381 151L466 249Z",
    fill: "#226595",
    stroke: "#226595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 50L381 151L488 145Z",
    fill: "#2975ac",
    stroke: "#2975ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 245L304 393L362 304Z",
    fill: "#113955",
    stroke: "#113955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 304L304 393L385 330Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 416L689 355L565 323Z",
    fill: "#3995dc",
    stroke: "#3995dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 151L325 182L362 304Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 540L512 540L492 445Z",
    fill: "#42a5f5",
    stroke: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 445L512 540L560 438Z",
    fill: "#42a5f5",
    stroke: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 438L636 540L642 416Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 208L636 148L611 211Z",
    fill: "#226595",
    stroke: "#226595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 211L636 148L506 122Z",
    fill: "#113955",
    stroke: "#113955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 364L281 414L304 393Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 393L281 414L355 447Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 447L392 540L492 445Z",
    fill: "#113955",
    stroke: "#113955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 540L563 540L560 438Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808 451L738 336L689 355Z",
    fill: "#3184c4",
    stroke: "#3184c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 540L392 540L355 447Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 182L256 245L362 304Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689 355L738 336L685 308Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 308L731 208L611 211Z",
    fill: "#42a5f5",
    stroke: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808 451L689 355L642 416Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 310L731 208L685 308Z",
    fill: "#3995dc",
    stroke: "#3995dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 540L636 540L560 438Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 245L221 364L304 393Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 414L324 540L355 447Z",
    fill: "#081e2e",
    stroke: "#081e2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 540L324 540L281 414Z",
    fill: "#226595",
    stroke: "#226595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 364L223 413L281 414Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 208L662 90L636 148Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 148L615 56L506 122Z",
    fill: "#226595",
    stroke: "#226595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 151L306 61L325 182Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 201L193 251L256 245Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506 122L385 50L488 145Z",
    fill: "#3184c4",
    stroke: "#3184c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 0L385 50L506 122Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808 451L779 310L738 336Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738 336L779 310L685 308Z",
    fill: "#081e2e",
    stroke: "#081e2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662 90L615 56L636 148Z",
    fill: "#3184c4",
    stroke: "#3184c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 201L256 245L180 108Z",
    fill: "#42a5f5",
    stroke: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 245L193 251L221 364Z",
    fill: "#113955",
    stroke: "#113955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 364L101 426L223 413Z",
    fill: "#113955",
    stroke: "#113955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 50L306 61L381 151Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 0L519 0L506 122Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 50L398 0L306 61Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678 0L553 0L615 56Z",
    fill: "#3995dc",
    stroke: "#3995dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615 56L553 0L506 122Z",
    fill: "#2975ac",
    stroke: "#2975ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 0L398 0L385 50Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 540L808 451L642 416Z",
    fill: "#226595",
    stroke: "#226595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 108L256 245L325 182Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 251L105 257L221 364Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 540L758 540L642 416Z",
    fill: "#42a5f5",
    stroke: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 426L200 540L223 413Z",
    fill: "#3995dc",
    stroke: "#3995dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223 413L200 540L281 414Z",
    fill: "#081e2e",
    stroke: "#081e2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 70L678 0L662 90Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662 90L678 0L615 56Z",
    fill: "#113955",
    stroke: "#113955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 70L662 90L731 208Z",
    fill: "#42a5f5",
    stroke: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 396L857 254L779 310Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 310L857 254L731 208Z",
    fill: "#081e2e",
    stroke: "#081e2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 61L180 108L325 182Z",
    fill: "#3995dc",
    stroke: "#3995dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 0L180 108L306 61Z",
    fill: "#3184c4",
    stroke: "#3184c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857 254L827 139L731 208Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 0L274 0L306 61Z",
    fill: "#3995dc",
    stroke: "#3995dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 151L105 257L165 201Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 201L105 257L193 251Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 139L803 70L731 208Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 339L101 426L221 364Z",
    fill: "#174769",
    stroke: "#174769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 108L121 151L165 201Z",
    fill: "#3995dc",
    stroke: "#3995dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 122L121 151L180 108Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 85L825 89L827 139Z",
    fill: "#2975ac",
    stroke: "#2975ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 139L825 89L803 70Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808 451L890 396L779 310Z",
    fill: "#226595",
    stroke: "#226595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857 254L960 193L827 139Z",
    fill: "#42a5f5",
    stroke: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865 485L890 396L808 451Z",
    fill: "#42a5f5",
    stroke: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 540L865 485L808 451Z",
    fill: "#081e2e",
    stroke: "#081e2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 257L68 339L221 364Z",
    fill: "#42a5f5",
    stroke: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 352L68 339L0 249Z",
    fill: "#226595",
    stroke: "#226595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274 0L208 0L306 61Z",
    fill: "#3995dc",
    stroke: "#3995dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 0L104 122L180 108Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 143L0 249L105 257Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885 0L800 0L803 70Z",
    fill: "#226595",
    stroke: "#226595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 70L800 0L678 0Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 447L102 540L101 426Z",
    fill: "#3995dc",
    stroke: "#3995dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 426L102 540L200 540Z",
    fill: "#226595",
    stroke: "#226595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 540L893 540L865 485Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865 485L960 482L890 396Z",
    fill: "#081e2e",
    stroke: "#081e2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 482L960 332L890 396Z",
    fill: "#081e2e",
    stroke: "#081e2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 396L960 332L857 254Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825 89L885 0L803 70Z",
    fill: "#2975ac",
    stroke: "#2975ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 332L960 260L857 254Z",
    fill: "#113955",
    stroke: "#113955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 260L960 193L857 254Z",
    fill: "#2975ac",
    stroke: "#2975ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 249L68 339L105 257Z",
    fill: "#3184c4",
    stroke: "#3184c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 339L0 352L101 426Z",
    fill: "#42a5f5",
    stroke: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 143L105 257L121 151Z",
    fill: "#3995dc",
    stroke: "#3995dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893 540L960 482L865 485Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 0L105 0L180 108Z",
    fill: "#2975ac",
    stroke: "#2975ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 122L0 143L121 151Z",
    fill: "#3184c4",
    stroke: "#3184c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 85L885 0L825 89Z",
    fill: "#0d2b41",
    stroke: "#0d2b41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 352L0 447L101 426Z",
    fill: "#113955",
    stroke: "#113955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893 540L960 540L960 482Z",
    fill: "#1c567f",
    stroke: "#1c567f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 93L0 143L104 122Z",
    fill: "#2975ac",
    stroke: "#2975ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 193L960 85L827 139Z",
    fill: "#2975ac",
    stroke: "#2975ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 447L0 540L102 540Z",
    fill: "#226595",
    stroke: "#226595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 0L0 93L104 122Z",
    fill: "#113955",
    stroke: "#113955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 85L960 0L885 0Z",
    fill: "#3995dc",
    stroke: "#3995dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 0L0 0L0 93Z",
    fill: "#081e2e",
    stroke: "#081e2e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.037b72a41ebc63a36006263df339acbb.svg";
export { ForwardRef as ReactComponent };